// removed by extract-text-webpack-plugin
module.exports = {"card":"src-components----about-module---card---Ek2_n","avatar":"src-components----about-module---avatar---2nu7V","messageForm":"src-components----about-module---messageForm---il1h1","hideMsg":"src-components----about-module---hideMsg---2sIU8","showMsg":"src-components----about-module---showMsg---2sW71","fadein":"src-components----about-module---fadein---nVrEG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/about.module.css
// module id = 116
// module chunks = 35783957827783 263791100135453